import type { AppDefinition } from '../../types/apps';

export const transcriptAppDefinition: AppDefinition = {
  appId: 'transcript',
  name: 'Transcripts',
  version: '1.0.0',
  description: 'Ingest and review voice transcriptions with entity extraction, audio playback, and mention timelines.',

  entityTypes: ['Transcript'],
  requiresEntity: false,
  requiresProps: false,

  component: 'transcript',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'Microphone',
    phosphorWeight: 'duotone' as const,
    color: '#6366f1',
    metadata: {
      source: 'app' as const,
      appId: 'transcript',
      isAppIcon: true,
    },
  },

  searchableSkeletonFields: {
    Transcript: ['summary', 'markdown'],
  },

  agenticToolIds: ['transcript_create', 'transcript_read'],

  features: ['entityExtraction', 'audioPlayback', 'mentionTimeline'],
  category: 'ai',
  isCore: false,
  isSystem: true,
  hidden: true,
};

export default transcriptAppDefinition;
